import { format } from 'date-fns';

export const getDateFormat = () => {
    return 'dd-MM-yyyy';
};

export const getFormattedDate = (date: string | Date) => {
    return format(new Date(date), getDateFormat());
};
